<template>
  <div>
    <slot></slot>
    <div v-if="place.detail && place.detail.content" class="mt-1">
      <p class="text-btn_secondary" v-html="place.detail.content.replace(/\\n/g, '<br />')"></p>
    </div>
    <template v-if="place.benefit_contents && place.benefit_contents.length > 0">
      <div v-for="benefitContent in place.benefit_contents" class="place-gift mt-4" v-bind:key="benefitContent.label">
        <h3 class="font-bold">{{ benefitContent.label }}</h3>
        <div class="inline-block mt-2 p-2 bg-beige rounded text-sm">
          {{ benefitContent.text }}
        </div>
      </div>
    </template>
    <template v-else-if="place.benefits_content && place.benefits_content.length > 0">
      <div class="place-gift mt-4">
        <h3 class="font-bold">{{ $t('tour_pass_benefit') }}</h3>
        <div class="inline-block mt-2 p-2 bg-light_gray rounded text-sm">
          {{ place.benefits_content }}
        </div>
      </div>
    </template>
    <template v-if="place.links && place.links.length > 0">
      <div v-for="link in place.links" class="mt-4" v-bind:key="link.id">
        <div class="mt-4">
          <a :href="link.url" :target="link.target" class="button-primary block">
            <span>
              {{ link.label }}
            </span>
          </a>
        </div>
      </div>
    </template>
    <div class="mt-8">
      <h3 class="section-title mb-2">{{ $t('tour_shop_information') }}</h3>
      <ul class="place-info">
        <li v-if="place.zipcode && place.zipcode.length > 0">
          <span>{{ $t('tour_location') }}：</span>
          <span>〒{{ place.zipcode }} {{ place.address }}</span>
        </li>
        <li v-if="!place.zipcode || place.zipcode.length <= 0">
          <span>{{ $t('tour_location') }}：</span>
          <span>{{ place.address }}</span>
        </li>
        <li v-if="place.phone_number && place.phone_number.length > 0">
          <span>{{ $t('tour_tel') }}：</span>
          <a :href="`tel:${ place.phone_number }`" class="inline-block text-link">
            <span class="mr-1">{{ place.phone_number }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="inline w-4">
              <path d="m556.47567 279.782859-.775371-.608385c-.356217-.279146-.875557-.216638-1.155136.139573l-2.039685 2.600512c-.279579.356211-.216641.875971.139576 1.155117l1.113606.873831c-.423864.646916-.986447 1.359339-1.721144 2.093596-.734698.734685-1.447132 1.297687-2.094059 1.721544l-.873845-1.113588c-.278723-.356211-.798919-.419147-1.154708-.139573l-2.600983 2.039651c-.355789.279146-.418726.799334-.139576 1.155117l.608395.775358c1.337526 1.337504 4.815351.028257 7.768269-2.924612 2.952491-2.952442 4.262188-6.430637 2.924661-7.768141" transform="translate(-544 -278)"/>
            </svg>
          </a>
        </li>
        <div v-if="place.phones && place.phones.length > 0">
          <li
            v-for="(phone, index) in place.phones"
            v-bind:key="index">
            <span>{{ $t('tour_tel') + String(index + 1) }}：</span>
            <a :href="`tel:${ phone.number }`" class="inline-block text-link">
              <span class="mr-1">{{ phone.number }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="inline w-4">
                <path d="m556.47567 279.782859-.775371-.608385c-.356217-.279146-.875557-.216638-1.155136.139573l-2.039685 2.600512c-.279579.356211-.216641.875971.139576 1.155117l1.113606.873831c-.423864.646916-.986447 1.359339-1.721144 2.093596-.734698.734685-1.447132 1.297687-2.094059 1.721544l-.873845-1.113588c-.278723-.356211-.798919-.419147-1.154708-.139573l-2.600983 2.039651c-.355789.279146-.418726.799334-.139576 1.155117l.608395.775358c1.337526 1.337504 4.815351.028257 7.768269-2.924612 2.952491-2.952442 4.262188-6.430637 2.924661-7.768141" transform="translate(-544 -278)"/>
              </svg>
            </a>
            <div v-if="phone.label && phone.label.length > 0">
              ({{ phone.label }})
            </div>
          </li>
        </div>
        <li v-if="place.business_hours && place.business_hours.length > 0" class="flex items-start">
          <span>{{ $t('tour_business_hours') }}：</span>
          <span>{{ place.business_hours }}</span>
        </li>
        <li v-if="place.regular_holiday && place.regular_holiday.length > 0">
          <span>{{ $t('tour_holoday') }}：</span>
          <span>{{ place.regular_holiday }}</span>
        </li>
        <li v-if="place.nearest_station && place.nearest_station.length > 0" class="flex items-start">
          <span>{{ $t('tour_nearest_station') }}：</span>
          <span>{{ place.nearest_station }}</span>
        </li>
        <li v-if="place.nearest_busstop && place.nearest_busstop.length > 0" class="flex items-start">
          <span>{{ $t('tour_nearest_busstop') }}：</span>
          <span>{{ place.nearest_busstop }}</span>
        </li>
        <li v-if="place.url && place.url.length > 0" class="flex items-start">
          <span>{{ $t('tour_website') }}：</span>
          <span>
            <a :href="place.url" class="break-all text-link">{{ place.url }}</a>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  }
}
</script>
